import React, {useEffect, useState} from 'react'
import api from "./store/api"
import CustomInput from "../../../components/CustomInput"
import CustomButton from "../../../components/CustomButton"
import AddIcon from "../../../components/Icons/add.svg"
import {Pagination, Popconfirm, Table} from "antd"
import ModalAudit from "../ModalAudit"
import UpdateIcon from "../../../components/Icons/update.svg"
import DeleteIcon from "../../../components/Icons/delete.svg"
import RestoreIcon from "../../../components/Icons/restore.svg"
import AuditIcon from "../../../components/Icons/audit.svg"
import Notifications from "../../../helpers/Notifications"
import ReCityChangeForm from "./change"
import {useDebounce} from "use-debounce"
import {dAction} from "../../../helpers/defaultAction"
import {useDispatch, useSelector} from "react-redux"
import LocalLoading from "../../../components/Loading/Local"
import {useTranslation} from "react-i18next"
import dayjs from "dayjs"

const ReCity = (props) => {
    const {isModify = false} = props
    const pageSize = 10
    const [visible, setVisible] = useState(false)
    const [visibleAudit, setVisibleAudit] = useState(false)
    const [record, setRecord] = useState(null)
    const [state, setState] = useState({items: [], count: 0})
    const [page, setPage] = useState(1)
    const [search, setSearch] = useState(null)
    const [idRecordAudit, setIdRecordAudit] = useState(null)
    const [searchValue] = useDebounce(search, 500)
    const {isLoading} = useSelector((state) => state.globalReducer)
    const {t} = useTranslation(['common', 'valid', 'action'])
    const dispatch = useDispatch()

    const remove = params => {
        dispatch(dAction(api.delete, params, changed, t('action:deleted')))
    }
    const restore = params => {
        dispatch(dAction(api.restore, params, changed, t('action:restored')))
    }

    useEffect(() => {
        onPaginationChange(1)
    }, [searchValue])

    const changed = (res, message) => {
        if (res === true) {
            Notifications.successNotice(message, '', 10)
            setVisible(false)
            onPaginationChange(page)
        }
    }

    function onPaginationChange(value) {
        setPage(value)
        const params = {
            name: searchValue?.trim(),
            pageSize: pageSize,
            page: value
        }
        const func = isModify ? api.getPagedAll : api.getPaged
        const sucFunction = (res) => setState({items: res.items, count: res.count})
        dispatch(dAction(func, params, sucFunction, null))
    }

    const columns = [
        {
            title       : t('common:code'),
            dataIndex   : 'code',
            key         : 'code'
        },
        {
            title       : t('common:title'),
            dataIndex   : 'name',
            key         : 'name'
        }
    ]

    const columnsAudit = [
        ...columns,
        {
            title       : t('common:zone'),
            dataIndex   : 'reZoneId',
            key         : 'reZoneId'
        },
        {
            title       : t('common:region'),
            dataIndex   : 'reRegionId',
            key         : 'reRegionId'
        }
    ]

    columns.push(
        {
            title       : t('common:zone'),
            dataIndex   : 'reZone',
            key         : 'reZone'
        },
        {
            title       : t('common:regionName'),
            dataIndex   : 'reRegion',
            key         : 'reRegion'
        }
    )

    if (isModify) {
        columns.push(
            {
                title       : t('common:dateCreate'),
                dataIndex   : 'createDate',
                key         : 'createDate',
                render      : (date) => dayjs(date).format("DD.MM.YYYY")
            },
            {
                dataIndex: "id",
                key: 'id',
                width: 100,
                render: (id, record) => (
                    <div className="changeIcon">
                        <img alt=""
                            src={UpdateIcon}
                            title={t('edit')}
                            onClick={() => {
                                setVisible(true)
                                setRecord(record)
                            }}
                        />
                        <Popconfirm
                            cancelText={t('no')}
                            okText={t('yes')}
                            placement="left"
                            title={!record.isDeleted ? t('valid:sureToDelete') : t('valid:sureToRestore')}
                            onCancel={(e) => {
                                e.stopPropagation()
                                return null
                            }}
                            onConfirm={(e) => {
                                e.stopPropagation()
                                !record.isDeleted ? remove({id}) : restore({id})
                            }}
                        >
                            <img alt=""
                                src={!record.isDeleted ? DeleteIcon : RestoreIcon}
                                title={!record.isDeleted ? t('action:delete') : t('action:restore')}
                            />
                        </Popconfirm>
                        <img alt=""
                            className="audit-icon-svg"
                            src={AuditIcon}
                            title={t('common:historyOfChange')}
                            onClick={() => {
                                setVisibleAudit(true)
                                setIdRecordAudit(id)
                            }}
                        />
                    </div>
                )
        })
    }

    return (
        <>
            <div className="header-admin-nsi">
                <CustomInput
                    maxLength={64}
                    placeholder={t('action:enterNameCode')}
                    onChange={(e) => setSearch(e.target.value)}
                />
                {isModify
                    ? (
                        <CustomButton
                            className="add-nsi"
                            type="green"
                            onClick={() => {
                                setRecord(null)
                                setVisible(true)
                            }}
                        >
                            <div>
                                <img alt="" src={AddIcon}/>
                                <span>
									{t('action:add')}
								</span>
                            </div>
                        </CustomButton>
                    )
                    : null
                }
            </div>
            <Table
                columns={columns}
                dataSource={state.items.map((el, idx) => ({key: el.code, ...el}))}
                loading={{indicator: <LocalLoading/>, spinning: isLoading}}
                pagination={false}
                scroll={{x: 1100}}
            />
            {
                state.count > pageSize &&
                <Pagination
                    showQuickJumper
                    current={page}
                    pageSize={pageSize}
                    showSizeChanger={false}
                    size="small"
                    total={state.count}
                    onChange={onPaginationChange}
                />
            }
            {isModify &&
                <ReCityChangeForm
                    changed={changed}
                    record={record}
                    setRecord={setRecord}
                    setVisible={setVisible}
                    visible={visible}
                />
            }
            <ModalAudit
                columns={columnsAudit}
                setIdRecordAudit={setIdRecordAudit}
                idRecordAudit={idRecordAudit}
                setVisible={setVisibleAudit}
                visible={visibleAudit}
                pageSize={pageSize}
                func={api.getPagedAudit}
            />
        </>
    )
}

export default ReCity